const controller = "settings/carriers/bitrix";

export default {
  controller,
  basicInfo: controller + "/basic-info",
};
